import { Helmet } from 'react-helmet-async';

export function Meta({
  title,
  description,
  canonical,
  ogImage,
}: {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical !== undefined && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonical !== undefined && <meta property="og:url" content={canonical} />}
      {ogImage !== undefined && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
